/* eslint-disable @next/next/no-img-element */
import styled from 'styled-components'
import { trackEvent } from 'lib/tracking/analytics-service'
import {
    AnalyticsEventProPlanPageImpression,
    AnalyticsEventProPlanPurchaseClick,
    AnalyticsEventProPlanSectionImpression,
} from 'lib/constants/AnalyticsEventType'
import VariantHeader from './VariantHeader'
import VariantPlusPlanFAQ from './VariantPlusPlanFAQ'
import VariantPlusPlanCheckoutPage from './VariantPlusPlanCheckoutPage'
import VariantPlusPlanReviews from './VariantPlusPlanReviews'
import VariantPlusPlanBenefits from './VariantPlusPlanBenefits'
import ProReferences from 'components/modules/LandingPage/ProReferences'
import VariantPlusPlanFooterCloud from './VariantPlusPlanFooterCloud'
import { useEffect } from 'react'

const Container = styled.div`
    background: linear-gradient(0deg, #001157, #001157),
        radial-gradient(90% 220% at 0% 0%, rgba(82, 240, 141, 0.8) 0%, rgba(41, 98, 255, 0.8) 100%),
        linear-gradient(0deg, rgba(82, 240, 141, 0.2), rgba(82, 240, 141, 0.2));

    background-blend-mode: lighten;
    height: 100%;
`

const Header = styled.div`
    min-height: calc(80vh + var(--navbar-height));
    display: grid;
    align-items: center;
    @media (max-width: 900px) {
        min-height: fit-content;
    }
`

interface Props {
    referrerScreen?: string
}

const VariantProLandingPage = ({ referrerScreen }: Props) => {
    const scrollToCheckout = () => {
        document.getElementById('checkout')?.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
        })
    }

    useEffect(() => {
        trackEvent(AnalyticsEventProPlanPageImpression, { referrerScreen })
        trackEvent(AnalyticsEventProPlanSectionImpression, { referrerScreen, value: 'hero' })
    }, [referrerScreen])

    const onGetPlusPlanButtonClick = (value: string) => {
        trackEvent(AnalyticsEventProPlanPurchaseClick, { referrerScreen, value })
        scrollToCheckout()
    }

    return (
        <Container>
            <Header>
                <VariantHeader onGetPlusPlanButtonClick={onGetPlusPlanButtonClick} />
            </Header>
            <ProReferences backgroundColor={'transparent'} />
            <VariantPlusPlanBenefits onGetPlusPlanButtonClick={onGetPlusPlanButtonClick} />
            <VariantPlusPlanCheckoutPage />
            <VariantPlusPlanReviews onGetPlusPlanButtonClick={onGetPlusPlanButtonClick} />
            <VariantPlusPlanFAQ />
            <VariantPlusPlanFooterCloud />
        </Container>
    )
}

export default VariantProLandingPage
